import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { withRouter } from "react-router-dom";
import ArchiveNewsletters from '../../native/screens/archivenewsletters';
import LastWeekData  from '../../native/screens/last-week';

export class LastWeek extends Component {
    constructor(props) {
        super(props);
        let postData = (process.browser) ? document.getElementById("postData") : null;
        let footerData = (process.browser) ? document.getElementById("footerData") : null;
        this.state = {
            searchQuery: "",
            locationHash: "",
            archiveSlug: this.props.match.params.archive_slug,
            archiveData: (postData) ? JSON.parse(postData.getAttribute('data')) : ((JSON.stringify(this.props.postData) != '{}') ? this.props.postData : null),
            footerData: (footerData) ? JSON.parse(footerData.getAttribute('data')) : ((JSON.stringify(this.props.footerData) != '{}') ? this.props.footerData : null)
        }
        if(process.browser) {
            if(postData) {
                postData.parentNode.removeChild(postData);
            }
            if(footerData) {
                footerData.parentNode.removeChild(footerData);
            }
            try {
                ReactGA.pageview(this.props.history.location.pathname);
            }
            catch(error) {
                console.log("GA tracking error =>", error);
            }
        }
    }

    componentDidMount = () => {
        setTimeout(function () {
            window.history.scrollRestoration = "manual";
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            setTimeout(function () {
                document.body.style.overflow = 'initial';
                document.body.style.position = 'initial';
            }, 20);
        }, 20);
        if(window.location.search != this.state.searchQuery) {
            this.setState({
                searchQuery: window.location.search
            })
        }
        if(window.location.hash != this.state.locationHash) {
            this.setState({
                locationHash: window.location.hash
            })
        }
    }

    componentDidUpdate = () => {
        if(window.location.search != this.state.searchQuery) {
            this.setState({
                searchQuery: window.location.search
            })
        }
        if(window.location.hash != this.state.locationHash) {
            this.setState({
                locationHash: window.location.hash
            })
        }
        if(this.state.archiveSlug != this.props.match.params.archive_slug) {
            this.setState({
                archiveSlug: this.props.match.params.archive_slug,
                archiveData: null,
                footerData: null
            })
        }
    }
    
    navigateToScreen = (route, params) => {
        let routeArr = route.split('?')
        const { history } = this.props;
        history.push({
          pathname: routeArr[0],
          search: routeArr[1] ? ('?' + routeArr[1]) : '',
          state: params
        });
    }

    render() {
        const { archiveSlug, archiveData, footerData, searchQuery, locationHash } = this.state;

        return (
            <LastWeekData  history={this.props.history} searchQuery={searchQuery} locationHash={locationHash} key={archiveSlug} navigateToScreen={this.navigateToScreen} archiveData={archiveData} archiveSlug={archiveSlug} footerData={footerData} params={this.props.params} newsletter={true}/>
        );
    }
}

export default withRouter(LastWeek);